import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
    {
        path: '/sign-up',
        component: () => import('./sign-up-page.vue'),
        meta: {
            layout: 'blank-layout'
        }
    }
]

export default routes;
